App.namespace.wrap('es6.shared.raf', (function () {
  return window.requestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.msRequestAnimationFrame
    || function(cb) { return setTimeout(cb, 16); }
})());
